import { Button, Flex, Text } from '@chakra-ui/react'
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { Link, useRouteError } from 'react-router-dom'

import { useUserSharedBaseRoutes } from '../hooks/usePersonaBaseUrl'

export function ErrorBoundary() {
  const error = useRouteError()
  const basicError = error as {
    name?: string
    stack?: string
    message?: string
  }
  const userSharedBaseRoutes = useUserSharedBaseRoutes()

  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <Flex
      justifyContent={'center'}
      alignItems={'center'}
      bgColor={'custom.red.light'}
      color={'custom.red.dark'}
      flexDir={'column'}
      h={'full'}
    >
      <Text fontWeight={'bold'}>Houve um erro</Text>
      <Text>
        Envie esses dados ao suporte ou volte a{' '}
        <Button
          as={Link}
          to={userSharedBaseRoutes?.static.home ?? '/'}
          variant={'link'}
          fontWeight={'bold'}
          textDecor={'underline'}
          color={'custom.red.dark'}
        >
          tela principal
        </Button>
      </Text>
      <Text as={'pre'} mt={'4'} whiteSpace={'pre-wrap'} px={'4'}>
        {basicError?.stack
          ? basicError.stack
          : `${basicError?.name} - ${basicError?.message}`}
      </Text>
    </Flex>
  )
}
